import { useEffect } from "react";
import { useBlocker } from "react-router";

export const leaveDialogText = "You have unsaved changes. Are you sure you want to leave page? Your changes will be lost.";

export const UnsavedChangesDialogTexts = {
  "default": "You have unsaved changes. Your changes will be lost.",
  "campaignsLeave": "You have unsaved changes. Your changes will be lost.",
  "campaignsCreate": "You have unsaved changes. Are you sure you want to create a new campaign? Your changes will be lost.",
  "campaignsChange": "You have unsaved changes. Are you sure you want to switch to another campaign? Your changes will be lost.",
  "leadsLeave": "You have unsaved changes. Your changes will be lost.",
  "leadsCreate": "You have unsaved changes. Are you sure you want to create a new lead? Your changes will be lost.",
  "leadsSearch": "You have unsaved changes. Are you sure you want to switch to another lead? Your changes will be lost.",
  "scriptsLeave": "You have unsaved changes. Are you sure you want to leave?",
  "scriptsCreate": "You have unsaved changes. Are you sure you want to create a new LLM?",
  "scriptsDuplicate": "You have unsaved changes. Are you sure you want to duplicate this LLM?",
  "toolsLeave": "You have unsaved changes. Your changes will be lost.",
  "toolsCreate": "You have unsaved changes. Are you sure you want to create a new tool? Your changes will be lost.",
  "toolsChange": "You have unsaved changes. Are you sure you want to switch to another tool? Your changes will be lost.",
};

export function useShowDialog(shouldBlock: boolean ) {
  /** Warn on browser/tab close/refresh/back */
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (!shouldBlock) return;
      e.preventDefault();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [shouldBlock]);

  /** Warn on in-app navigation (links, router transitions) */
  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    if (blocker.state === "blocked") {
      if (!shouldBlock) {
        blocker.proceed();
        return;
      }
      const ok = window.confirm(leaveDialogText);
      if (ok) blocker.proceed();
      else blocker.reset();
    }
  }, [blocker, shouldBlock]);

  function showConfirmDialog(text: string) {
    return window.confirm(text);
  }

  return {
    showConfirmDialog,
  };
}